import { _ as e } from "./extends-093996c9.js";
import c from "react";

var t = function t(_t) {
  var l = _t.dark,
      r = void 0 === l ? "#000000" : l,
      h = _t.light,
      n = void 0 === h ? "#ffffff" : h,
      a = _t.red,
      o = void 0 === a ? "#A01622" : a,
      i = _t.schema,
      p = {
    isotypebackground: o,
    isotypeletter: n,
    letters: r
  };
  return "light" === (void 0 === i ? "common" : i) && (p.isotypebackground = o, p.isotypeletter = n, p.letters = n), c.createElement("svg", e({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1431.7 507.7"
  }, _t), c.createElement("g", null, c.createElement("g", {
    fill: p.letters
  }, c.createElement("polyline", {
    points: "704.7,390.5 664.9,390.5 664.9,371.8 765.6,371.8 765.6,390.5 725.8,390.5 725.8,505.9 704.7,505.9 704.7,390.5 \t\t"
  }), c.createElement("path", {
    d: "M971.7,505.9h-25.1l-22.9-32.6c-3,0.4-6.3,0.6-9.6,0.6h-13.2v32h-21.1V371.8h34.3c36.9,0,57.2,20.3,57.2,51.3 c0,20.7-9.3,36.7-26.8,44.8L971.7,505.9 M913.4,455.8c25.8,0,36.2-12.2,36.2-32.7c0-20.3-10.6-32.5-36.2-32.5h-12.5v65.3H913.4z"
  }), c.createElement("path", {
    d: "M980,438.8c0-39.6,30.2-68.8,68.4-68.8c24.9,0,42,9.6,53.7,26l-16.2,11.4c-8.9-12-20.3-18.4-38.1-18.4 c-26.6,0-46,21.3-46,49.7c0,29,19.8,49.7,46.7,49.7c17.4,0,30.2-6.6,40.2-19.6l16.4,11.3c-13.8,18.3-31.4,27.4-57.4,27.4 C1009.5,507.7,980,478.5,980,438.8"
  }), c.createElement("path", {
    d: "M1308.5,505.9h-25.1l-22.9-32.6c-3,0.4-6.3,0.6-9.6,0.6h-13.2v32h-21.2V371.8h34.3 c36.9,0,57.2,20.3,57.2,51.3c0,20.7-9.3,36.7-26.8,44.8L1308.5,505.9 M1250.1,455.8c25.9,0,36.3-12.2,36.3-32.7 c0-20.3-10.7-32.5-36.3-32.5h-12.3v65.3H1250.1z"
  }), c.createElement("path", {
    d: "M1334.1,505.9h-21.3l58.8-136.9h1.2l59,136.9h-22.3l-7.7-18.7h-59.9L1334.1,505.9 M1372,415.4l-22.3,53h44.2 L1372,415.4z"
  }), c.createElement("polyline", {
    points: "1204,487.2 1137.7,487.2 1137.7,464.5 1194.7,464.5 1194.7,446.1 1137.7,446.1 1137.7,390.5 1204,390.5 1204,371.8 1116.6,371.8 1116.6,505.9 1204,505.9 1204,487.2 \t\t"
  }), c.createElement("polyline", {
    points: "799.9,464.5 856.9,464.5 856.9,446.1 799.9,446.1 799.9,390.5 866.9,390.5 866.9,371.8 778.9,371.8 778.9,505.9 867,505.9 867,487.2 799.9,487.2 799.9,464.5 \t\t"
  }), c.createElement("polyline", {
    points: "480.3,371.9 501.3,371.9 501.3,487.2 561.9,487.2 561.9,505.9 480.3,505.9 480.3,371.9 \t\t"
  }), c.createElement("path", {
    d: "M568.1,505.9h-21.3l58.8-136.8h1.3l58.9,136.8h-22.3l-7.7-18.7h-60L568.1,505.9 M606,415.4l-22.3,53h44.1 L606,415.4z"
  })), c.createElement("g", null, c.createElement("path", {
    fill: p.isotypebackground,
    d: "M408.4,130C376.5,52.6,299.5-0.6,210.5,0C93.5,0.7-0.7,96.2,0,213.2c0.7,117,96.2,211.3,213.2,210.5 c20.2-0.1,39.6-3.1,58-8.5l-0.1,0.1c0.2-0.1,0.3-0.1,0.5-0.2c6.2-1.8,12.4-4,18.4-6.3c1.1-0.3,5.1-3,6.2-3.2 c8.9-5.7,13.2-7.8,23.3-7.9c21.6-0.1,39.3,17.3,39.4,38.9c0,5.6,0.1,9.8-1.9,15.7c-4,13.3-8.2,27.6-9.3,38.7c0,0.1,0,0.2,0,0.3 c-0.1,0.6-0.2,1.2-0.2,1.9c0,0.1,0,0.1,0,0.2c0.1,4.8,4,8.6,8.8,8.5c3.3,0,6.1-1.9,7.6-4.6l0.1,0C483.7,296.7,408.4,130,408.4,130 "
  }), c.createElement("path", {
    fill: p.isotypeletter,
    d: "M139.5,241v14.4c-9.6,5.2-20.7,7.9-33.3,7.9c-10.2,0-18.9-2.1-26-6.2c-7.1-4.1-12.7-9.8-16.9-17 c-4.1-7.2-6.2-15-6.2-23.4c0-13.3,4.7-24.5,14.2-33.6c9.5-9.1,21.2-13.6,35.1-13.6c9.6,0,20.3,2.5,32,7.5v14.1 c-10.7-6.1-21.2-9.2-31.4-9.2c-10.5,0-19.2,3.3-26.1,9.9c-6.9,6.6-10.4,14.9-10.4,24.9c0,10,3.4,18.3,10.2,24.8 c6.8,6.5,15.5,9.7,26.1,9.7C118.1,251.2,129,247.8,139.5,241"
  }), c.createElement("polygon", {
    fill: p.isotypeletter,
    points: "152.9,170.7 166,170.7 166,250.3 207.2,250.3 207.2,262.2 152.9,262.2 \t\t"
  }), c.createElement("path", {
    fill: p.isotypeletter,
    d: "M279.7,170.7h13.1v51.9c0,7-0.5,12.3-1.5,15.9c-1,3.6-2.3,6.6-3.8,8.9c-1.5,2.4-3.3,4.5-5.5,6.4 c-7.2,6.2-16.7,9.4-28.4,9.4c-11.9,0-21.5-3.1-28.7-9.3c-2.2-1.9-4-4.1-5.5-6.4c-1.5-2.4-2.8-5.3-3.7-8.7c-1-3.5-1.5-8.9-1.5-16.2 v-51.8h13.2v51.9c0,8.6,1,14.6,2.9,17.9c2,3.4,5,6.1,9,8.1c4,2,8.8,3,14.2,3c7.8,0,14.1-2,19-6.1c2.6-2.2,4.4-4.8,5.6-7.7 c1.1-3,1.7-8,1.7-15.3V170.7z"
  }), c.createElement("path", {
    fill: p.isotypeletter,
    d: "M339.2,262.2h-31v-91.5h24c7.6,0,13.5,1,17.7,3c4.2,2,7.5,4.8,9.7,8.4c2.2,3.6,3.3,7.7,3.3,12.3 c0,9-4.6,15.4-13.9,19.3c6.7,1.3,12,4,15.9,8.3c3.9,4.2,5.9,9.3,5.9,15.2c0,4.7-1.2,8.8-3.6,12.5c-2.4,3.7-5.9,6.7-10.6,9 C352,261.1,346.2,262.2,339.2,262.2 M332.6,182.4h-11.3v27.5h8.7c7,0,11.9-1.3,14.9-4c2.9-2.7,4.4-6.1,4.4-10.3 C349.4,186.8,343.8,182.4,332.6,182.4 M333.6,221.6h-12.2v29h12.9c7.2,0,12-0.6,14.6-1.7c2.6-1.1,4.6-2.9,6.2-5.2 c1.6-2.4,2.3-4.9,2.3-7.6c0-2.8-0.8-5.4-2.5-7.7c-1.6-2.3-3.9-4-7-5.2C344.9,222.1,340.1,221.6,333.6,221.6"
  }))));
};

export { t as ClubLaTercera };